import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InvoiceListPage from "../features/invoice/InvoiceListPage";
import InvoiceLayout from "../features/invoice/InvoiceLayout2026";

export default function InvoicePage({ onNavigate, onboardingContext }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [view, setView] = useState("list"); // "list" or "editor"
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [navigationAction, setNavigationAction] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Handle onboarding deep-link or command launcher
  useEffect(() => {
    if (onboardingContext?.action === 'create') {
      handleNavigateToEditor(null, { action: 'create' });
    } else if (onboardingContext?.invoiceId) {
      handleNavigateToEditor(onboardingContext.invoiceId);
    }
  }, [onboardingContext]);

  // Handle URL parameters for direct navigation (e.g., from dashboard)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const action = searchParams.get('action');
    
    if (action === 'create') {
      handleNavigateToEditor(null, { action: 'create' });
      // Clean up URL parameters after opening editor
      navigate('/invoices', { replace: true });
    }
  }, [location.search, navigate]);

  const handleNavigateToEditor = (invoiceId, options = {}) => {
    setSelectedInvoiceId(invoiceId);
    setNavigationAction(options.action || null);
    setView("editor");
  };

  const handleNavigateToList = () => {
    setSelectedInvoiceId(null);
    setNavigationAction(null);
    setView("list");
    // Trigger list refresh when returning from editor
    setRefreshTrigger((prev) => prev + 1);
  };

  if (view === "editor") {
    return (
      <InvoiceLayout
        invoiceId={selectedInvoiceId}
        initialAction={navigationAction}
        onBack={handleNavigateToList}
        onNavigate={onNavigate}
      />
    );
  }

  return (
    <InvoiceListPage
      onNavigateToEditor={handleNavigateToEditor}
      refreshTrigger={refreshTrigger}
      onboardingContext={onboardingContext}
      onNavigate={onNavigate}
    />
  );
}